module.exports = __webpack_public_path__ + "static/media/logo.5fdd8cc2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.svg
 ** module id = 442
 ** module chunks = 0
 **/